import { CoreService } from '../services'
import { OptionsConfig } from '../configs'
import * as Sentry from '@sentry/angular-ivy'

export class HistoryUtil {
  public static onRouteChange(route: string | number | any[], core: CoreService): void {
    if (route[0] === 'loading' || route[0] === 'home') {
      return
    }
    let history = core.services.storage.getSync(core.services.storage.keys.utils.history) || []
    history = history.slice(Math.max(history.length - 50, 0))
    history = history.map(h => [h[0], h[1].replace('#', '')])
    route[1] = route[1].replace('#', '')

    if (!history.length || (history.length && history[history.length - 1][0] !== route[0])) {
      history.push(route)
    }
    core.services.storage.set(core.services.storage.keys.utils.history, history)
  }

  public static getLocalStorageHistory() {
    const history: string = window.localStorage.getItem(`${OptionsConfig.strings.app_prefix}utils_history_history`)
    let value: any
    if (history && history.length > 0) {
      try {
        value = JSON.parse(history)
      } catch (e) {
        console.log(e)
      }
    }
    return value
  }

  public static navigateBack(): void {
    const history = this.getLocalStorageHistory() || []
    let navigateTo: [string, string] | false = ['', '']
    if (history && history.length > 0) {
      navigateTo = HistoryUtil.findClosestValidRoute(history)
    }
    window.history.back()
  }

  public static clear(core: CoreService): void {
    core.services.storage.clear(core.services.storage.keys.utils.history)
  }

  public static findClosestValidRoute(history: any[]): [string, string] | false {
    if (!history) {
      return false
    }
    let i = history.length - 2
    for (i; i > 0; i--) {
      if (HistoryUtil.isValid(history, history[i])) {
        return history[i]
      }
    }
    return false
  }

  private static isValid(history: any[], historyRecord: [string, string]): boolean {
    const invalidRoutesForBackNavigation: string[] = [
      'category',
      'cert',
      'checkout',
      'company',
      'company-carrier',
      'consent',
      'customer',
      'depot',
      'group',
      'login',
      'loading',
      'payment',
      'price-level',
      'inventory-exports',
      'producer',
      'product',
      'product-move-pack',
      'shop',
      'supplier',
      'user',
      'vat',
      'voucher',
    ]
    return (
      !invalidRoutesForBackNavigation.includes(historyRecord[0]) && history[history.length - 1][1] !== historyRecord[1]
    )
  }
}
